import React from "react";
import MemberInfo from "../../../components/checkout/MemberInfo";
import { MemberInfoSkeleton, CardSkeleton } from "./FulfillmentSkeletons";
import { DetailRow, formatVal } from "./DetailRow";

export default function OrderDetailsGrid({
    selectedOrder,
    loadingDetails,
    memberLoading,
    memberInfo
}) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* COLUMN 1 */}
            <div className="space-y-6">
                {memberLoading ? (
                    <MemberInfoSkeleton />
                ) : (
                    <MemberInfo member={memberInfo} />
                )}

                {/* Payment Card */}
                {loadingDetails ? (
                    <CardSkeleton title="Payment" rows={5} />
                ) : (
                    <div className="bg-white p-5 border border-gray-200 rounded-lg shadow-xs space-y-4">
                        <h3 className="text-xs font-bold uppercase tracking-wider text-gray-900 border-b pb-2">
                            Payment
                        </h3>
                        <div className="space-y-3 text-xs">
                            <DetailRow
                                label="Payment Status"
                                value={
                                    <span className="text-green-600 font-bold">
                                        {formatVal(selectedOrder?.payment?.payment_status)}
                                    </span>
                                }
                            />
                            <DetailRow label="Paid At" value={formatVal(selectedOrder?.payment?.paid_at)} />
                            <DetailRow label="Paid On" value={formatVal(selectedOrder?.payment?.paid_on)} />
                            <DetailRow label="IP Address" value={formatVal(selectedOrder?.payment?.ip_address)} />
                            <DetailRow label="Transaction ID" value={formatVal(selectedOrder?.payment?.transaction_id)} />
                        </div>
                    </div>
                )}
            </div>

            {/* COLUMN 2 */}
            <div className="space-y-6">
                {/* Shipping Details Card */}
                {loadingDetails ? (
                    <CardSkeleton title="Shipping Details" rows={8} />
                ) : (
                    <div className="bg-white p-5 border border-gray-200 rounded-lg shadow-xs space-y-4">
                        <h3 className="text-xs font-bold uppercase tracking-wider text-gray-900 border-b pb-2">
                            Shipping Details
                        </h3>
                        <div className="space-y-3 text-xs">
                            <DetailRow label="Shipment Status" value={formatVal(selectedOrder?.shipping_details?.shipment_status)} />
                            <DetailRow label="Shipment Provider" value={formatVal(selectedOrder?.shipping_details?.shipment_provider)} />
                            <DetailRow label="ETD" value={formatVal(selectedOrder?.shipping_details?.etd)} />
                            <DetailRow label="Courier" value={formatVal(selectedOrder?.shipping_details?.courier)} />
                            <DetailRow label="AWB" value={formatVal(selectedOrder?.shipping_details?.awb)} />
                            <DetailRow label="Tracking URL" value={
                                selectedOrder?.shipping_details?.tracking_url && selectedOrder.shipping_details.tracking_url !== "-" ? (
                                    <a href={selectedOrder.shipping_details.tracking_url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline break-all">
                                        {selectedOrder.shipping_details.tracking_url}
                                    </a>
                                ) : "-"
                            } />
                            <DetailRow label="Shipping Address" value={formatVal(selectedOrder?.shipping_details?.shipping_address)} />
                            <DetailRow label="Delivery Option" value={formatVal(selectedOrder?.shipping_details?.delivery_option)} />
                            <DetailRow label="Slot Details" value={formatVal(selectedOrder?.slot_details)} />
                        </div>
                    </div>
                )}

                {/* Order Details Card */}
                {loadingDetails ? (
                    <CardSkeleton title="Order Details" rows={5} />
                ) : (
                    <div className="bg-white p-5 border border-gray-200 rounded-lg shadow-xs space-y-4">
                        <h3 className="text-xs font-bold uppercase tracking-wider text-gray-900 border-b pb-2">
                            Order Details
                        </h3>
                        <div className="space-y-3 text-xs">
                            <DetailRow label="Order Status" value={formatVal(selectedOrder?.order_details?.order_status)} />
                            <DetailRow label="Issue Credits" value={`${formatVal(selectedOrder?.order_details?.issue_credits)} Credits`} />
                            <DetailRow label="Return Credits" value={`${formatVal(selectedOrder?.order_details?.return_credits)} Credits`} />
                            <DetailRow
                                label="Available Credits"
                                value={
                                    <span className="text-green-600 font-bold">
                                        {formatVal(selectedOrder?.order_details?.available_credits)} Credits
                                    </span>
                                }
                            />
                            <DetailRow label="Total Amount" value={`₹ ${formatVal(selectedOrder?.order_details?.total_amount)}`} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
